import React from "react";
// Time Line
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { Skeleton } from "@mui/material";
// Time Line

const OrderHistoryTimeLine = () => {
  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
        transition: "all 0.5s ease",
      }}
    >
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div>Delivered</div>
            <div className="date-time">
              <Skeleton width={"50%"} height={20} animation="wave" />
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div>Out Of Delivery</div>
            <div className="date-time">
              <Skeleton width={"50%"} height={20} animation="wave" />
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div>Preparing</div>
            <div className="date-time">
              <Skeleton width={"50%"} height={20} animation="wave" />
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot className="active-dot-bar" />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div className="status-title active-status">Pending</div>
            <div className="date-time">
              <Skeleton width={"50%"} height={20} animation="wave" />
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
};

export default OrderHistoryTimeLine;
